export const HACKLE_DEVICE_COOKIE_NAME = '_hackle_hid';
export const HACKLE_TEST_CASE_NUMBER = {};
